import { jsx } from 'react/jsx-runtime';
import deepEqual from 'deep-equal';
import { createContext, useState, useEffect, useCallback } from 'react';

// @ts-ignore <- this ignore is needed because this is an easiest way to create a generic context in React
const FilterContext = createContext(null);
function FiltersProvider({ children, defaultFilters = {}, filters: initialFilters, onApplyFilters, onFilterUpdate, }) {
    const [filters, setFilters] = useState(initialFilters);
    useEffect(() => {
        if (initialFilters) {
            setFilters(initialFilters);
        }
    }, [initialFilters]);
    const handleFiltersChange = useCallback((fieldName, value) => {
        setFilters((prevState) => Object.assign({}, prevState, { [fieldName]: value }));
        if (onFilterUpdate) {
            onFilterUpdate(fieldName, value);
        }
    }, [onFilterUpdate]);
    const applyFilters = () => {
        onApplyFilters(filters);
    };
    const setDefaultFilters = () => {
        setFilters(defaultFilters);
        onApplyFilters(defaultFilters);
    };
    const setInitialFilters = () => {
        setFilters(initialFilters);
        onApplyFilters(initialFilters);
    };
    const checkAreFiltersChanged = () => {
        return !deepEqual(defaultFilters, initialFilters, { strict: true });
    };
    const checkAreFiltersTheSameAsInitial = () => {
        return deepEqual(initialFilters, filters, { strict: true });
    };
    const checkAreFiltersTheSameAsDefault = () => {
        return deepEqual(defaultFilters, filters, { strict: true });
    };
    return (jsx(FilterContext.Provider, { value: {
            areFiltersInitialAndDefaultDifferent: checkAreFiltersChanged(),
            areFiltersTheSameAsDefault: checkAreFiltersTheSameAsDefault(),
            areFiltersTheSameAsInitial: checkAreFiltersTheSameAsInitial(),
            defaultFilters,
            filters,
            initialFilters,
            handleApplyFilters: applyFilters,
            handleFiltersChange,
            setDefaultFilters,
            setInitialFilters,
        }, children: children }));
}

export { FilterContext, FiltersProvider };
//# sourceMappingURL=FiltersProvider.js.map
